/** FA catalog — FE-4: ارزیابی‌ها، بسته‌ها، قالب‌ها، سازندهٔ ترکیب. */
export const assessFa: Record<string, string> = {
  'as.you': 'شما',
  'as.sectionTitle': 'ارزیابی‌ها',
  'as.sectionSub':
    'هر ارزیابی سند لحظهٔ خودش است و به پرونده تعلق دارد، نه به یک نوبت. هیچ‌کدام بازنویسی یا حذف نمی‌شود.',
  'as.new': 'ارزیابی تازه',
  'as.emptyTitle': 'هنوز ارزیابی‌ای نیست',
  'as.emptyBody':
    'نبودِ ارزیابی چیزی را قفل نمی‌کند — نوبت‌گرفتن و ساختن بسته آزاد است. پیش‌نویس را هر وقت جلسهٔ ارزیابی برگزار شد شروع کنید.',
  'as.emptyGate': 'ارزیابی اولیه نقطهٔ شروعِ پیشنهادی درمان است؛ بسته بدون آن هم ساخته می‌شود.',
  'as.derivedNote':
    '«ارزیابی‌شده» هیچ‌وقت یک برچسب ذخیره‌شده نیست: این فهرست خود حقیقت است، و هیچ وضعیتی روی پرونده نوشته نمی‌شود.',
  'as.reassessNote':
    'ارزیابی مجدد نمونه دیگری از همان سند است و هیچ‌وقت ارزیابی قبلی را بازتفسیر نمی‌کند. چرخه کامل ارزیابی مجدد بخش پیشرفت است (FE-7).',
  'as.type.initial': 'ارزیابی اولیه',
  'as.type.reassessment': 'ارزیابی مجدد',
  'as.status.draft': 'پیش‌نویس',
  'as.status.completed': 'تکمیل‌شده',
  'as.colAssessment': 'ارزیابی',
  'as.colStatus': 'وضعیت',
  'as.colSigned': 'امضا شده',
  'as.continue': 'ادامه نوشتن',
  'as.view': 'دیدن',
  'as.startedLine': 'شروع‌شده {date} توسط {who}',
  'as.signedLine': 'امضا شده توسط {who} · {date} — امضاکننده و زمان ثابت‌اند.',
  'as.draftStrip': 'شروع‌شده {date} توسط {who} — هر تغییر به ویرایشگرش نسبت داده می‌شود.',
  'as.amendedChip': '{n, plural, one {# اصلاحیه} other {# اصلاحیه}}',

  'as.newTitle': 'ارزیابی تازه',
  'as.newSub':
    'برای شروع فقط نوع لازم است. بقیه — تشخیص، یافته‌ها، توصیه‌ها — اختیاری اند و به هر ترتیبی می‌آیند.',
  'as.typeInitialBody': 'اولین تصویر بالینی این چرخه — معمولا بعد از اولین جلسه ارزیابی.',
  'as.typeReassessBody':
    'نگاهی بعدی در طول مسیر. برچسب، قضاوت بالینی خود ارزیاب است؛ سیستم هیچ‌وقت تحمیلش نمی‌کند.',
  'as.selected': 'انتخاب‌شده',
  'as.intakeCard': 'معارفه (اختیاری)',
  'as.intakeCardSub':
    'اگر معارفه‌ای هست می‌توانید پیوندش کنید — حتی اگر هنوز در جریان باشد. ارزیابی فقط به آن ارجاع می‌دهد و چیزی را کپی نمی‌کند.',
  'as.intakeLinked': 'معارفهٔ پیوندی',
  'as.intakeNone': '— هیچ —',
  'as.intakeOption': 'معارفه — {date} · {status}',
  'as.intakeHelp': 'اختیاری. ارزیابیِ بدون معارفه کاملاً عادی است.',
  'as.startDraft': 'شروع پیش‌نویس',
  'as.startNote':
    'پیش‌نویس به پرونده تعلق دارد، نه به شما — هر همکار مجازی می‌تواند ادامه‌اش دهد، و هر ویرایش نسبت داده می‌شود.',
  'as.noChecklistTitle': 'بدون چک‌لیست، بدون درصد',
  'as.noChecklistBody':
    'یک ارزیابی تقریبا خالی معتبر است. هیچ فهرست محتوای الزامی، نوار پیشرفت یا بخش اجباری وجود ندارد — عمدا.',

  'as.pageTitle': '{type} — {name}',
  'as.draftSub':
    'همه‌چیز اختیاری است و همان‌طور ذخیره می‌شود. کامل کردن و امضا کردن تصمیمی جداگانه است، برای وقتی نوشته آماده است.',
  'as.completedSub':
    'کامل‌شده یعنی امضا شده — نه برای همیشه قفل. تغییر بعدی یک اصلاحیه ثبت‌شده است.',
  'as.amendedSub':
    'کامل‌شده، بعدا اصلاح‌شده — هر دو حقیقت کنار هم خوانده می‌شوند؛ نسخه اصلی امضا شده هیچ‌وقت بی‌صدا بازنویسی نمی‌شود.',
  'as.writeup': 'نوشته بالینی',
  'as.signedWriteup': 'نوشتار امضاشده',
  'as.diagnosis': 'برداشت بالینی',
  'as.diagnosisHelp':
    'یادداشت بالینی آزاد شما — هر جزئیات توضیحی پشت تشخیص‌های بالا، یا یک برداشت بدون تشخیص. اختیاری.',
  // ZOY-700: بخش مشترک تشخیص — یک فهرست واحد برای همهٔ کلینیک‌ها، برچسب‌ها بر اساس کد.
  'as.dxSection': 'تشخیص',
  'as.dxSectionHelp':
    'هر تشخیصی که صدق می‌کند را تیک بزنید — یک فهرست مشترک برای همه کلینیک‌ها. هر ارائه تشخیص خودش را لازم دارد؛ «دیگر» عبارت خودتان را می‌گیرد. اختیاری.',
  'as.dxSignedNote': 'انتخاب همان‌طور که امضا شد.',
  'as.dxNone': 'هیچ تشخیصی انتخاب نشده.',
  'as.dxOtherText': 'تشخیص دیگر',
  'as.dxOtherHelp': 'عبارت خودتان برای تشخیصی که در فهرست نیست.',
  'as.dxGroup.intellectual_disabilities': 'ناتوانی\u200cهای ذهنی',
  'as.dx.intellectual_developmental_disorder': 'اختلال رشد ذهنی (ناتوانی ذهنی)',
  'as.dx.global_developmental_delay': 'تاخیر رشد جهانی',
  'as.dx.unspecified_intellectual_developmental_disorder': 'اختلال رشد ذهنی نامشخص (ناتوانی ذهنی)',
  'as.dxGroup.communication_disorders': 'اختلالات ارتباطی',
  'as.dx.language_disorder': 'اختلال زبان',
  'as.dx.speech_sound_disorder': 'اختلال صدای گفتار',
  'as.dx.childhood_onset_fluency_disorder': 'اختلال روانی گفتار با شروع کودکی (لکنت)',
  'as.dx.social_pragmatic_communication_disorder': 'اختلال ارتباط اجتماعی (کاربردی)',
  'as.dx.unspecified_communication_disorder': 'اختلال ارتباطی نامشخص',
  'as.dxGroup.autism_spectrum_disorder': 'اختلال طیف اوتیسم',
  'as.dx.autism_spectrum_disorder': 'اختلال طیف اوتیسم (ASD)',
  'as.dxGroup.attention_deficit_hyperactivity_disorders': 'اختلالات کم توجهی / بیش‌فعالی',
  'as.dx.adhd': 'اختلال کم توجهی / بیش‌فعالی (ADHD)',
  'as.dx.adhd_predominantly_inattentive': 'ارائه غالبا بی‌توجه',
  'as.dx.adhd_predominantly_hyperactive_impulsive': 'ارائه غالبا بیش‌فعال / تکانشی',
  'as.dx.adhd_combined': 'ارائه ترکیبی',
  'as.dx.other_specified_adhd': 'اختلال کم توجهی / بیش‌فعالی مشخص‌شده دیگر',
  'as.dx.unspecified_adhd': 'اختلال کم توجهی / بیش‌فعالی نامشخص',
  'as.dxGroup.specific_learning_disorder': 'اختلال یادگیری خاص (SLD)',
  'as.dx.specific_learning_disorder': 'اختلال یادگیری خاص (SLD)',
  'as.dx.sld_impairment_in_reading': 'با اختلال در خواندن',
  'as.dx.sld_impairment_in_written_expression': 'با اختلال در بیان نوشتاری',
  'as.dx.sld_impairment_in_mathematics': 'با اختلال در ریاضیات',
  'as.dxGroup.motor_disorders': 'اختلالات حرکتی',
  'as.dx.developmental_coordination_disorder': 'اختلال هماهنگی رشدی (DCD)',
  'as.dx.stereotypic_movement_disorder': 'اختلال حرکت کلیشه‌ای',
  'as.dx.tic_disorders': 'اختلالات تیک',
  'as.dx.tourettes_disorder': 'اختلال تورت',
  'as.dx.persistent_motor_or_vocal_tic_disorder': 'اختلال تیک حرکتی یا صوتی پایدار (مزمن)',
  'as.dx.provisional_tic_disorder': 'اختلال تیک احتمالی',
  'as.dx.other_specified_tic_disorder': 'اختلال تیک مشخص‌شده دیگر',
  'as.dx.unspecified_tic_disorder': 'اختلال تیک نامشخص',
  'as.dxGroup.other_neurodevelopmental_disorders': 'اختلالات رشد عصبی دیگر',
  'as.dx.other_specified_neurodevelopmental_disorder': 'اختلال رشد عصبی مشخص‌شده دیگر',
  'as.dx.unspecified_neurodevelopmental_disorder': 'اختلال رشد عصبی نامشخص',
  'as.dxGroup.other': 'سایر',
  'as.dx.other': 'دیگر (متن آزاد)',
  'as.amend.dxOtherEmpty': '(هیچ)',
  'as.outcomes': 'نتایج مورد انتظار',
  'as.outcomesHelp': 'متن آزاد — نه اهداف ساختاریافته؛ مدل هدف/پیشرفت پرسش بخش پیشرفت است.',
  'as.narrative': 'روایت ارزیاب',
  'as.narrativeHelp': 'اختیاری — جلسه به زبان خودتان.',
  'as.saveWriteup': 'ذخیره نوشته',
  'as.savedKept': 'ذخیره شد. چیزی الزامی نیست؛ خالی خالی می‌ماند.',

  'as.findings': 'یافته‌ها',
  'as.findingsSub': 'مشاهدات شما، به زبان خودتان — بدون سطر پیش‌فرض، بدون ابزار، بدون امتیاز.',
  'as.colName': 'نام',
  'as.colValue': 'مقدار',
  'as.colUnit': 'واحد',
  'as.findingsFoot':
    'یک یافته ثبت‌شده روی ارزیابی می‌ماند — سطرها قابل‌ویرایش اند، و حذف یکی در این نسخه ارائه نمی‌شود.',
  'as.addFinding': 'افزودن یافته',
  'as.newFinding': 'یافته جدید',
  'as.editFinding': 'ویرایش یافته',
  'as.nameHelp': 'تنها بخش الزامی.',
  'as.valueHelp': 'متن ساده — همان‌طور که خودتان می‌گویید، نه یک متریک عددی.',
  'as.notes': 'یادداشت‌ها',
  'as.addFindingCta': 'افزودن یافته',
  'as.addFindingNote': 'به این ارزیابی اضافه شد، به‌نام شما.',
  'as.noFindings': 'هنوز یافته‌ای نوشته نشده.',
  'as.noTemplatesTitle': 'بدون قالب، بدون سطر پیش‌فرض',
  'as.noTemplatesBody':
    'بدون فهرست ابزار، بدون واژگان از پیش تعیین شده — عمدا. یک دسته‌بندی بالینی که سیستم ندارد، این‌جا ساخته نمی‌شود.',

  'as.recs': 'پیشنهاد خدمت‌ها',
  'as.recsSub':
    'یک پیشنهاد بالینی، نه تعهد درمانی — بدون قیمت، بدون زمان، بدون رزرو. بسته تصمیمی بعدی و جداگانه است.',
  'as.colService': 'خدمت',
  'as.colProposed': 'جلسات پیشنهادی',
  'as.proposed': '{n, plural, one {# پیشنهادی} other {# پیشنهادی}}',
  'as.proposedNone': 'بدون تعداد پیشنهادی',
  'as.recsFoot':
    'هر خدمت حداکثر یک‌بار در هر ارزیابی ظاهر می‌شود. مثل یافته‌ها، یک توصیه ثبت‌شده در این نسخه حذف نمی‌شود.',
  'as.addRec': 'افزودن توصیه',
  'as.newRec': 'توصیه جدید',
  'as.editRec': 'ویرایش توصیه',
  'as.service': 'خدمت',
  'as.serviceHelp':
    'از خدمات فعال مرکز. خدماتی که این ارزیابی از قبل توصیه می‌کند دوباره پیشنهاد نمی‌شوند.',
  'as.noServiceLeft': 'همه خدمات فعال از قبل توصیه شده‌اند.',
  'as.proposedSessions': 'جلسات پیشنهادی',
  'as.proposedHelp': 'اختیاری — یک پیشنهاد، هیچ‌وقت تعداد ثابت.',
  'as.addRecCta': 'افزودن توصیه',
  'as.addRecNote':
    'یک پیشنهاد ثبت‌شده بعدا می‌تواند بسته‌ای را شروع کند — هیچ‌وقت بسته‌ای را الزام نمی‌کند.',
  'as.noRecs': 'هنوز توصیه‌ای نیست.',
  'as.recDisabledNow': 'حالا در این مرکز غیرفعال شده — سطر همان‌طور که نوشته شد خواندنی می‌ماند.',
  'as.noPriceTitle': 'بدون قیمت، بدون زمان این‌جا',
  'as.noPriceBody':
    'قیمت‌گذاری، تخفیف و زمان‌بندی مال بسته‌ها و تقویم است. یک توصیه فقط می‌گوید چه چیزی، و تقریبا چقدر، از نظر بالینی.',
  'as.dupRec': 'آن خدمت از قبل توسط این ارزیابی توصیه شده.',
  'as.serviceDisabledErr': 'آن خدمت در این مرکز غیرفعال است و نمی‌تواند توصیه شود.',

  'as.intakeContextTitle': 'بافتار معارفه',
  'as.intakeContextSub':
    'آنچه خانواده پیش از ارزیابی آورده — ارجاع زنده به خودِ معارفه، نه رونوشتی منجمد از آن. منبع هر خط کنارش نوشته شده.',
  'as.intakeLinkedChip': 'به این ارزیابی پیوند شده',
  'as.intakeLiveNote':
    'معارفهٔ در جریان هم پیوندشدنی است؛ وضعیتش همیشه همین‌جا دیده می‌شود و ممکن است بعداً کامل شود.',
  'as.openIntake': 'بازکردن معارفه',
  'as.referencedTitle': 'ارجاع داده‌شده، هیچ‌وقت کپی نشده',
  'as.referencedBody':
    'این صفحه معارفه را همان‌طور که الان هست نشان می‌دهد. اگر معارفه بعداً اصلاح شود، اینجا هم همان اصلاح دیده می‌شود — و گفتهٔ اصلی خانواده طبق قاعدهٔ همیشگی محفوظ می‌ماند.',
  'as.noAutofillTitle': 'هیچ‌چیز خودکار پر نمی‌شود',
  'as.noAutofillBody':
    'معارفه هرگز تشخیص یا نتیجه‌ای را پیش‌نویس نمی‌کند. برداشت بالینی را ارزیاب می‌نویسد.',
  'as.noneRecorded': 'چیزی ثبت‌نشده.',

  'as.completeCta': 'تکمیل و امضا…',
  'as.whoCanSignTitle': 'چه کسی می‌تواند امضا کند',
  'as.whoCanSignBody':
    'دارنده مجوز تکمیل که مرکز او را مجاز به ارزیابی علامت زده — هر شرط جداگانه بررسی می‌شود.',
  'as.youHoldBoth': 'شما هر دو را دارید.',
  'as.qualificationUnknown':
    'علامت مجاز بودن به ارزیابی شما از این‌جا خواندنی نیست؛ سامانه مرکز هنگام امضا بررسی می‌کند.',
  'as.completeTitle': 'کامل و امضا کردن این ارزیابی',
  'as.completeBody':
    'امضا شده به‌نام {who}؛ زمان را سیستم تنظیم می‌کند. بخش‌های خالی خالی می‌مانند — چیزی الزامی نیست.',
  'as.fact1': 'وضعیت کامل‌شده می‌شود و هیچ‌وقت به پیش‌نویس برنمی‌گردد.',
  'as.fact2': 'امضاکننده و زمان امضا برای همیشه ثابت می‌مانند.',
  'as.fact3': 'ساختن بسته برای {name} باز می‌شود — قاعده بسته‌ها.',
  'as.fact4': 'تغییرات بعدی به‌عنوان اصلاحیه ثبت‌شده اضافه می‌شوند، هیچ‌وقت به‌عنوان بازنویسی.',
  'as.completeNote': 'هیچ امضای دوم و هیچ بازبینی دومی وجود ندارد — یک ارزیاب مسئول، یک امضا.',
  'as.notYet': 'هنوز نه',
  'as.signCta': 'امضا و تکمیل',
  'as.notQualified':
    'سامانه مرکز این امضا را نپذیرفت: این حساب در این مرکز مجاز به ارزیابی علامت نخورده. چیزی تغییر نکرد.',
  'as.alreadyCompleted': 'این ارزیابی از قبل امضا شده — صفحه به‌روز شد.',

  'as.amend': 'اصلاح…',
  'as.amending':
    'در حال اصلاح — هر تغییر بعد از امضا به‌نام شما ثبت می‌شود؛ نسخه اصلی امضا شده قابل بازسازی می‌ماند.',
  'as.amendDone': 'پایان اصلاح',
  'as.gateOpenTitle': 'ارزیابی امضا شد',
  'as.gateOpenBody':
    'پیشنهادهای این ارزیابی می‌تواند نقطهٔ شروع بستهٔ درمانی {name} باشد — ترکیب بسته آزادانه ویرایش می‌شود.',
  'as.toPackage': 'ساخت بسته از این پیشنهادها',

  'as.ledgerTitle': 'تاریخچه این سند',
  'as.ledgerSub':
    'یک اصلاحیه صادقانه تغییر بعد از امضا نامیده می‌شود؛ متن امضا شده قابل بازسازی می‌ماند.',
  'as.ledger.created': 'پیش‌نویس شروع شد',
  'as.ledger.signed': 'امضا شد',
  'as.ledger.amendment': 'اصلاحیه',
  'as.ledgerCreated': 'پیش‌نویس ارزیابی شروع شد.',
  'as.ledgerSigned': 'تکمیل و امضای ارزیابی.',
  'as.amend.title': 'اصلاحیه‌های بعد از امضا',
  'as.amend.sub':
    'نسخه امضا شده بالا همان‌طور که امضا شد نشان داده می‌شود. هر تغییر بعد از امضا این‌جا فهرست می‌شود، با این‌که چه کسی و چه زمانی.',
  'as.amend.change': '{before} → {after}',
  'as.amend.empty': '(خالی)',
  'as.amend.noteOn': 'یادداشت روی «{label}»',
  'as.amend.unknownQuestion': 'پرسشی که دیگر در این فرم نیست',
  'as.amend.unreadable': '(خواندنی نیست)',
  'as.amend.field': 'فیلد دیگر',
  'as.amend.findingAdded': 'یافته بعد از امضا اضافه شد',
  'as.amend.findingRemoved': 'یافته بعد از امضا حذف شد',
  'as.amend.recAdded': 'توصیه بعد از امضا اضافه شد',
  'as.amend.recRemoved': 'توصیه بعد از امضا حذف شد',
  'as.amend.reason': 'دلیل: {reason}',
  'as.amend.unknownService': 'خدمتی که دیگر در فهرست نیست',
  'as.amendedState': 'بعد از امضا اصلاح شد',
  'as.amendedSubLimited':
    'کامل‌شده، بعدا بعد از امضا اصلاح‌شده. چه چیزی عوض شد، چه کسی عوضش کرد و چه زمانی، بخشی از تاریخچه پرونده است.',
  'as.noSyncTitle': 'اصلاحیه‌ها هیچ‌وقت در بسته موجود همگام نمی‌شوند',
  'as.noSyncBody':
    'اگر بسته‌ای از این ارزیابی شروع‌شده، اصلاحیه بعدی چیزی در آن عوض نمی‌کند — بسته تصمیم جداگانه خودش را نگه می‌دارد.',
  'as.noDeleteNote':
    'ارزیابی‌ها هیچ‌وقت حذف یا باطل نمی‌شوند — حتی پیش‌نویس‌ها. چنین اقدامی وجود ندارد.',

  'path.assessmentOpen': 'باز کردن',
  'path.assessmentNew': 'ارزیابی تازه',
  'path.packageNew': 'بستهٔ تازه',
  'path.packageDone': '{n, plural, one {# بسته} other {# بسته}}',

  'pk.sectionTitle': 'بسته‌ها',
  'pk.new': 'بستهٔ تازه',
  'pk.emptyTitle': 'هنوز بسته‌ای نیست',
  'pk.emptyBody':
    'بسته تصمیم عملیاتی و مالیِ درمان است؛ پیشنهاد می‌شود پس از ارزیابی ساخته شود، اما الزامی نیست.',
  'pk.state.in_use': 'در جریان',
  'pk.state.stopped': 'متوقف‌شده',
  'pk.state.completed': 'کامل‌شده',
  'pk.servicesSessions':
    '{services, plural, one {# خدمت} other {# خدمت}} · {sessions, plural, one {# جلسه} other {# جلسه}}',
  'pk.total': 'جمع بسته',
  'pk.open': 'باز کردن',

  'pk.newTitle': 'بسته جدید برای {name}',
  'pk.newSub':
    'چند بسته می‌توانند کنار هم وجود داشته باشند، و همان خدمت می‌تواند در بیش از یکی از آن‌ها بیاید.',
  'pk.gateOkTitle': 'ارزیابی انجام شده — {type}، {date}',
  'pk.gateOkBody': 'پیشنهادهای ارزیابیِ {name} می‌تواند نقطهٔ شروع این بسته باشد.',
  'pk.gateNoTitle': 'بسته پیش از ارزیابی اولیه',
  'pk.gateNoBody':
    '{name} هنوز ارزیابی امضاشده‌ای ندارد. ارزیابی اولیه توصیه می‌شود اما الزامی نیست — بسته را از روی قالب یا دستی بسازید.',
  'pk.viewAssessment': 'دیدن ارزیابی',
  'pk.start.manual': 'دستی',
  'pk.start.manualBody': 'خالی شروع کنید و خدمات را یکی‌یکی اضافه کنید.',
  'pk.start.template': 'از روی قالب',
  'pk.start.templateBody': 'از یک قالب شروع کنید — ترکیب و قیمت بسته‌اش برای بررسی شما می‌آید.',
  'pk.start.assessment': 'از ارزیابی',
  'pk.start.assessmentNone': 'ارزیابی تکمیل‌شده‌ای در این پرونده نیست.',
  'pk.start.assessmentBody':
    'از آنچه ارزیابی توصیه کرد پیش‌پر می‌شود. یک پیشنهاد برای بررسی — نه یک نسخه.',
  'pk.noTemplates': 'هنوز قالبی در این مرکز نیست.',
  'pk.noRecs': 'ارزیابی امضا شده هیچ خدمتی توصیه نمی‌کند — چیزی برای پیش‌پر کردن نیست.',
  'pk.pickTemplate': 'قالب',
  'pk.pickAssessment': 'ارزیابی',
  'pk.name': 'نام بسته',
  'pk.nameHelp':
    'با یک پیش‌فرض معقول پیش‌پر می‌شود — شروع از قالب به‌جای آن نام قالب را می‌آورد. قبل از ذخیره هر طور خواستید ویرایشش کنید.',
  'pk.defaultName': 'بسته — {name}',
  'pk.explicitPrice': 'قیمت بسته',
  'pk.explicitPriceHelp':
    'اختیاری — قیمتی پیشنهادی به‌جای جلسات × قیمت واحد. قیمت خود قالب این‌جا می‌آید؛ خالی بگذارید تا از قیمت‌های واحد محاسبه شود.',
  'pk.discount': 'تخفیف بسته',
  'pk.discountNone': 'ندارد',
  'pk.discountFixed': 'مبلغ ثابت',
  'pk.discountPercent': 'درصدی',
  'pk.discountValue': 'مقدار تخفیف',
  'pk.discountHelp': 'یک تخفیف در سطح بسته — ثابت یا درصد. دفترداری پرداخت این‌جا نیست.',
  'pk.problem.negative': 'تخفیف نمی‌تواند منفی باشد.',
  'pk.problem.percentOutOfRange': 'تخفیف درصدی نمی‌تواند از ۱۰۰ بیشتر باشد.',
  'pk.problem.fixedExceedsGross': 'تخفیف ثابت نمی‌تواند از جمع ناخالص بسته بیشتر باشد.',
  'pk.totals.sessions': 'جلسه‌ها',
  'pk.totals.before': 'پیش از تخفیف',
  'pk.totals.discount': 'تخفیف',
  'pk.totals.total': 'جمع بسته',
  'pk.previewNote':
    'جمع‌ها پیش‌نمایش چیزی است که سامانه مرکز ثبت می‌کند؛ مبلغ‌های ذخیره‌شده مال خودش است.',
  'pk.createCta': 'ساختن بسته',
  'pk.createNote':
    'قیمت‌های واحد همین حالا عکس‌برداری می‌شوند — تغییر بعدی قیمت فهرست هیچ‌وقت این بسته را بازنویسی نمی‌کند.',
  'pk.notAccountingTitle': 'این حسابداری نیست',
  'pk.notAccountingBody':
    'بسته برنامه و واقعیت‌های قیمتش را ثبت می‌کند. چه کسی چه چیزی و چه زمانی پرداخت کرد سطح پرداخت‌هاست، و این صفحه خلافش را ادعا نمی‌کند.',
  'pk.concurrentTitle': 'بسته‌های هم‌زمان طبیعی اند',
  'pk.concurrentBody':
    '{name} ممکن است بسته دیگری هم داشته باشد که همان خدمت را دارد. هیچ هشداری برای آن وجود ندارد — واقعیت عادی مرکز است.',
  'pk.prefillNote':
    'پیشنهادها هیچ‌وقت الزام نمی‌کنند: بسته می‌تواند با آن‌ها فرق کند، یا اصلا از آن‌ها شروع نشود. اصلاحیه بعدی ارزیابی هیچ‌وقت به‌تنهایی در این بسته همگام نمی‌شود.',
  'pk.noPlanTitle': 'طرح درمان جداگانه‌ای وجود ندارد',
  'pk.noPlanBody':
    'در نسخه اول، برنامه‌ریزی درمان دقیقا همین است: توصیه‌های ارزیابی ← بررسی ← بسته اختیاری.',
  'pk.err.duplicate': 'هر خدمت یک‌بار در هر بسته می‌آید.',
  'pk.err.disabled': 'یکی از خدمات در این مرکز غیرفعال است.',
  'pk.err.discount': 'تخفیف در برابر این جمع معتبر نیست.',
  'pk.err.composition': 'بسته به یک نام و دست‌کم یک خدمت نیاز دارد.',
  'pk.err.plannedBelow':
    'تعداد برنامه‌ریزی‌شده نمی‌تواند کمتر از جلسات از قبل برگزار شده شود. چیزی عوض نشد.',

  'pk.facts.provenance': 'شروع',
  'pk.prov.assessment': 'از ارزیابی',
  'pk.prov.template': 'از روی قالب',
  'pk.prov.manual': 'دستی',
  'pk.facts.discount': 'تخفیف',
  'pk.facts.total': 'جمع بسته',
  'pk.facts.gross': 'پیش از تخفیف',
  'pk.headNote':
    'پیشرفت جلسات را می‌شمارد، نه پول را. وضعیت پرداخت هیچ عددی روی این صفحه عوض نمی‌کند.',
  'pk.progressTitle': 'مصرف',
  'pk.progressSummary': '{delivered} از {planned} برگزار شده',
  'pk.progress.planned': 'برنامه‌ریزی‌شده',
  'pk.progress.scheduled': 'زمان‌بندی شده',
  'pk.progress.delivered': 'برگزار شده',
  'pk.progress.remaining': 'ماندهٔ بی‌نوبت',
  'pk.course.title': 'سیر بسته',
  'pk.course.sub':
    'هر نوبتی که به این بسته نسبت داده‌شده، به ترتیب، با سرنوشتی که داشته. فقط یک جلسه برگزار شده شمارنده را جابه‌جا می‌کند.',
  'pk.course.kind.delivered': 'انجام‌شده',
  'pk.course.kind.voided': 'باطل‌شده — حساب نمی‌شود',
  'pk.course.kind.in_progress': 'در جریان',
  'pk.course.kind.scheduled': 'برنامه‌ریزی‌شده',
  'pk.course.kind.cancelled': 'لغوشده — چیزی کم نکرد',
  'pk.course.kind.no_show': 'نیامد — چیزی کم نکرد',
  'pk.course.kind.incomplete': 'ناقص — چیزی نگرفت',
  'pk.course.sessionN': 'جلسه {n} از {planned}',
  'pk.course.empty': 'هنوز نوبتی به این سطر نسبت داده نشده.',
  'pk.course.unreadable': 'دیدن سیر بسته به دسترسی نوبت‌ها نیاز دارد.',
  'pk.course.stillScheduled': 'نوبتش هنوز زنده است و برنامه‌ریزی‌شده به شمار می‌آید',
  'pk.consumeTitle': 'چه چیزی جلسه مصرف می‌کند — و چه چیزی هیچ‌وقت',
  'pk.consumeBody':
    'فقط جلسهٔ برگزارشده مصرف می‌کند. جلسهٔ لغوشده یا نیامدنْ جلسه‌ای از بسته کم نمی‌کند؛ جابه‌جایی نوبت فقط جابه‌جایی است، نه مصرف دوباره؛ و پرداخت هیچ اثری روی این شمارش ندارد.',
  'pk.editTitle': 'نام، قیمت و تخفیف',
  'pk.editNote':
    'ویرایش‌ها نسبت داده و با مقادیر قبلی دفتر می‌شوند. ویرایش هیچ‌وقت بسته‌ای را کامل یا بسته نمی‌کند.',
  'pk.clearPrice': 'خالی بگذارید تا دوباره از قیمت‌های واحد محاسبه شود.',
  'pk.lines': 'خدمات این بسته',
  'pk.lineSnapshot': 'قیمت واحد عکس‌برداری شده',
  'pk.addLine': 'افزودن ردیف خدمت',
  'pk.changePlanned': 'تغییر تعداد برنامه‌ریزی‌شده',
  'pk.plannedHelp': 'هیچ‌وقت کمتر از آنچه از قبل برگزار شده.',
  'pk.lineNote':
    'افزودن یک سطر یا بالا بردن تعداد در یک بسته کامل‌شده، خودش آن را به «در استفاده» برمی‌گرداند — ویرایش هیچ‌وقت با کامل‌شدن قفل نمی‌شود.',
  'pk.lifecycleTitle': 'چرخه عمر',
  'pk.life.byEnding': 'با «پایان درمان»',
  'pk.life.derived': 'مشتق شده',
  'pk.life.in_use': 'در جریان',
  'pk.life.in_useBody':
    'جلسات می‌توانند در برابر آن زمان‌بندی و برگزار شوند. وضعیت پیش‌فرض بعد از ساخت.',
  'pk.life.completed': 'کامل‌شده',
  'pk.life.completedBody':
    'یک شرط زنده و مشتق شده — نه یک قفل: بسته تا وقتی هر جلسه برنامه‌ریزی‌شده برگزار شود، کامل‌شده نشان داده می‌شود. بعدا تعداد برنامه‌ریزی‌شده را بالا ببرید یا سطری اضافه کنید و خودش به «در استفاده» برمی‌گردد.',
  'pk.life.stopped': 'متوقف‌شده',
  'pk.life.stoppedBody':
    'با ثبت «پایان درمان» — ترک درمان یا ترخیص — برای مراجع، این خدمت یا همین بسته متوقف می‌شود. روی آن نوبت تازه گرفته نمی‌شود و نوبت‌های آینده‌اش لغو شده‌اند. اگر مراجع برگردد، «ادامهٔ بسته» در همان پایان درمان آن را دوباره باز می‌کند.',
  'pk.understandTitle': 'آنچه کاربر باید بفهمد',
  'pk.understandBody':
    'شمارش‌ها و فعالیت همیشه دیده می‌شوند؛ بسته کامل‌شده اگر برنامه‌اش بزرگ شود خودش برمی‌گردد؛ و هیچ‌چیزی حذف نمی‌شود — تاریخچه مصرف سر جایش می‌ماند.',
  'pk.validityTitle': 'تاریخ‌های اعتبار — یک پیشنهاد جداگانه، نه رفتار موجود',
  'pk.validityBody':
    'تاریخ شروع، پایان یا انقضا امروز وجود ندارد، و این صفحه ادعا نمی‌کند که دارد.',
  'pk.terms': 'شرایط پرداخت',
  'pk.terms.per_session': 'جلسه‌ای',
  'pk.terms.upfront_expected': 'انتظار پرداخت پیشاپیش',
  'pk.termsHelp':
    'پیش پرداخت انتظار می‌رود هیچ‌وقت مسدود نمی‌کند — رزرو و برگزاری هشدار می‌دهند تا وقتی کمتر از جمع بسته به آن نشان‌دار شده.',
  'pk.progress.overScheduled': 'بیش از برنامه رزرو شد',
  'pk.progress.overDelivered': 'بیش از برنامه برگزار شد',
  'pk.repriceTitle.raised': 'برنامه بالا رفت — جاهای خالی برگزار نشده مبلغ‌های جدید را می‌گیرند',
  'pk.repriceTitle.reduced':
    'برنامه کم شد — جاهای خالی برگزار نشده باقی‌مانده مبلغ‌های جدید را می‌گیرند',
  'pk.repriceTitle.unchanged':
    'تعداد برنامه‌ریزی‌شده عوض نشد — جاهای خالی برگزار نشده مبلغ‌های جدید را می‌گیرند',
  'pk.repriceBody':
    '{frozen, number} جلسهٔ تحویل‌شده مبلغ خود را نگه می‌دارد · {repriced, number} جایگاه تحویل‌نشده بازقیمت‌گذاری شد · مبلغ پکیج {before} ← {after}.',
  'pk.repriceWithin':
    '{n, number} تحویل فراتر از برنامهٔ پیشین اکنون درون برنامه است؛ مبلغ فهرست‌خدماتی آن‌ها تغییر نمی‌کند.',
  'pk.fundTitle': 'تأمین مالی',
  'pk.perSession': 'مبلغ هر جلسه',
  'pk.perSessionSub':
    'مبلغ قابل پرداخت موثر هر جلسه برنامه‌ریزی‌شده تحت تخفیف فعلی — دقیقا همان‌طور که سامانه مرکز تخصیص می‌دهد. هنگام برگزاری روی جلسه عکس‌برداری می‌شود.',
  'pk.perSessionNone': 'هنوز هیچ جلسه‌ای روی این بسته قیمت نخورده.',
  'pk.perSessionCount': '{n} جلسه',
  'pk.sessionN': 'جلسه {n}',
  'pk.base': 'پایه {amount}',

  'cb.title': 'ترکیب بسته',
  'cb.subAssess': 'از توصیه‌های ارزیابی پیش‌پر می‌شود — قبل از ذخیره هر چیزی را تنظیم کنید.',
  'cb.subTemplate': 'از قالب پیش‌پر می‌شود — قبل از ذخیره هر چیزی را تنظیم کنید.',
  'cb.subManual': 'خدمات را یکی‌یکی اضافه کنید؛ هر کدام یک‌بار می‌آید.',
  'cb.chipAssess': 'از ارزیابی پیش‌پر شده',
  'cb.chipTemplate': 'از قالب پیش‌پر شده',
  'cb.addService': 'افزودن خدمت',
  'cb.service': 'خدمت',
  'cb.planned': 'جلسات برنامه‌ریزی‌شده',
  'cb.unitPrice': 'قیمت واحد',
  'cb.lineTotal': 'جمع ردیف',
  'cb.suggested': 'ارزیابی {n} پیشنهاد داد',
  'cb.suggestedNone': 'ارزیابی تعدادی پیشنهاد نکرده',
  'cb.changed': 'این‌جا {n} تعیین شد',
  'cb.fromTemplate': 'قالب: {n}',
  'cb.remove': 'برداشتن',
  'cb.noLines': 'هنوز خدمتی نیست.',
  'cb.skipped': 'رد شد — در این مرکز غیرفعال است: {names}',
  'cb.noPrice': 'قیمتی تنظیم نشده — در تنظیمات مرکز تعیین کنید',
  'cb.allAdded': 'همه خدمات فعال از قبل در ترکیب هستند.',
  'pk.unpricedTitle': 'قیمتی کم است',
  'pk.unpricedBody':
    'این خدمات قیمت تنظیم شده ندارند، بنابراین این بسته هنوز ساخته نمی‌شود: {names}. برای هر کدام در تنظیمات مرکز → خدمات قیمت تعیین کنید (۰ یک خدمت عمدا رایگان را ثبت می‌کند)، بعد برگردید.',
  'pk.err.unpricedNamed':
    '{name} قیمت تنظیم شده ندارد، بنابراین بسته رد شد. در تنظیمات مرکز → خدمات قیمت تعیین کنید (۰ یک خدمت عمدا رایگان را ثبت می‌کند).',
  'pk.err.unpriced':
    'یکی از خدمات قیمت تنظیم شده ندارد، بنابراین بسته رد شد. در تنظیمات مرکز → خدمات قیمت تعیین کنید (۰ یک خدمت عمدا رایگان را ثبت می‌کند).',

  'tpl.tab': 'قالب‌های بسته',
  'tpl.title': 'قالب‌های بسته',
  'tpl.sub':
    'نقاط شروع قابل‌استفاده مجدد: یک نام، خدمات و تعداد جلسه هر کدام — و وقتی مرکز بسته‌ای می‌فروشد، قیمت بسته خود قالب. قیمت‌های واحد خدمت همچنان هنگام ساختن بسته واقعی عکس‌برداری می‌شوند.',
  'tpl.new': 'قالب تازه',
  'tpl.emptyTitle': 'هنوز قالبی نیست',
  'tpl.emptyBody': 'بسته‌ها همچنان می‌توانند دستی یا از یک ارزیابی ساخته شوند.',
  'tpl.sessions': '{n, plural, one {# جلسه} other {# جلسه}}',
  'tpl.priceChip': 'قیمت قالب',
  'tpl.lineItem': '{name} — {n, plural, one {# جلسه} other {# جلسه}}',
  'tpl.priceLine': 'قیمت قالب — {price}',
  'tpl.lifecycleTitle': 'ویرایش و بایگانی — پیشنهادی، نه رفتار موجود',
  'tpl.lifecycleBody':
    'قالب‌ها امروز می‌توانند ساخته و استفاده شوند. ویرایش، بایگانی و نسخه‌بندی برنامه‌ریزی‌شده‌اند — یک قالب تغییر یافته هیچ‌وقت نباید بسته‌های از قبل ساخته‌شده از آن را بازنویسی کند — و هنوز در دسترس نیستند.',
  'tpl.createTitle': 'قالب تازه',
  'tpl.createSub':
    'یک نام، خدمات و تعداد جلسات — به‌علاوه یک قیمت قالب اختیاری وقتی قالب یک بسته تجاری است.',
  'tpl.name': 'نام قالب',
  'tpl.nameHelp':
    'کوتاه و توصیفی — همان‌طور که کارکنان بلند می‌گویند، مثلا «بسته گفتاردرمانی در محل ۵ جلسه‌ای».',
  'tpl.description': 'توضیح',
  'tpl.descHelp': 'اختیاری — برای وقتی که نام تنها کافی نیست.',
  'tpl.price': 'قیمت قالب',
  'tpl.priceHelp':
    'اختیاری — برای یک بسته تجاری که قیمت پیشنهادی اش جلسات × قیمت واحد نیست. خالی بماند، بسته از قیمت‌های واحد خدمات قیمت می‌خورد.',
  'tpl.holds': 'خدمت‌های قالب',
  'tpl.createCta': 'ساختن قالب',
  'tpl.createNote':
    'تعداد جلسات این‌جا زندگی می‌کند؛ قیمت‌های واحد خدمت هنگام ساختن بسته واقعی عکس‌برداری می‌شوند.',
  'tpl.offerTitle': 'قیمت قالب یک پیشنهاد است، نه حسابداری',
  'tpl.offerBody':
    'وقتی قالبی قیمت خودش را دارد، بسته‌های ساخته‌شده از آن با همان قیمت شروع می‌شوند — و اپراتور قبل از ذخیره قیمت و ترکیب را بررسی می‌کند.',
  'tpl.created': 'قالب ساخته شد.',
  /* فرم‌های ساخت‌یافته (ZOY-538/539) — فقط پوستهٔ رابط؛ واژه‌های بالینی
     (عنوان‌ها، بخش‌ها، پرسش‌ها، گزینه‌ها) از خود سند فرم می‌آیند. */
  'fmt.title': 'قالب ارزیابی',
  'fmt.simpleChip': 'ساده — متن آزاد',
  'fmt.versionChip': 'نسخه {n, number}',
  'fmt.subPick':
    'نوشته زیر، ارزیابی ساده است و همیشه در دسترس. انتخاب یک قالب ساختاریافته، فرمی به این ارزیابی اضافه می‌کند — پاسخ‌ها همان‌طور که می‌روید ذخیره می‌شوند.',
  'fmt.subHave':
    'این ارزیابی فرم ساختاریافته زیر را دارد، سنجاق شده به نسخه‌ای که با آن شروع شد. نوشته متن آزاد کنارش در دسترس می‌ماند.',
  'fmt.existsRefetched': 'فرمی از قبل روی این ارزیابی شروع‌شده بود — حالا زیر نشان داده می‌شود.',
  'fmt.actionFailed': 'آن انجام نشد — چیزی عوض نشد. اتصال را بررسی کنید و دوباره تلاش کنید.',
  'fmt.noTemplates': 'همین حالا هیچ قالب ساختاریافته‌ای برای انتخاب در دسترس نیست.',
  'fmt.use': 'استفاده از این قالب',
  'fmt.actionsNote':
    'تغییر یا دور انداختن، پاسخ‌های فعلی را کنار می‌گذارد — آن‌ها در دفتر کلینیک می‌مانند، اما از این ارزیابی خارج می‌شوند.',
  'fmt.switch': 'تغییر قالب',
  'fmt.discard': 'دور انداختن فرم',
  'fmt.switchTitle': 'قالب ارزیابی عوض شود؟',
  'fmt.switchBody':
    'پاسخ‌های وارد شده روی «{from}» کنار گذاشته می‌شوند و یک فرم تازه «{to}» خالی شروع می‌شود.',
  'fmt.consequenceTitle': 'این کار چه می‌کند',
  'fmt.switchEffect':
    'هیچ‌چیزی حذف نمی‌شود: پاسخ‌های کنار گذاشته شده در دفتر بالینی می‌مانند، اما دیگر روی این ارزیابی ظاهر نمی‌شوند و به فرم جدید منتقل نمی‌شوند.',
  'fmt.switchCta': 'تغییر قالب',
  'fmt.discardTitle': 'این فرم دور انداخته شود؟',
  'fmt.discardBody':
    'فرم «{name}» و پاسخ‌هایش کنار گذاشته می‌شوند، و این دوباره یک ارزیابی ساده می‌شود.',
  'fmt.discardEffect':
    'هیچ‌چیزی حذف نمی‌شود: پاسخ‌ها در دفتر بالینی می‌مانند، اما دیگر روی این ارزیابی ظاهر نمی‌شوند.',
  'fmt.discardCta': 'دور انداختن و بازگشت به ساده',

  'sf.sealedChip': 'هنگام امضا مهر و موم شد',
  'sf.sealedSubAmended':
    'دقیقا همان‌طور که امضا شد نشان داده می‌شود. تغییرات بعد از امضا زیر «اصلاحیه‌های بعد از امضا» فهرست می‌شوند.',
  'sf.sealedSubCurrent':
    'هنگام امضا مهر و موم شد. پاسخ‌ها همان‌طور که حالا هستند نشان داده می‌شوند — هر تغییر بعد از امضا به‌نام اصلاح‌کننده ثبت می‌شود.',
  'sf.sealedSub':
    'دقیقا همان‌طور که ثبت شد نشان داده می‌شود — عبارت و پاسخ‌ها با ارزیابی امضا شده منجمد شده‌اند.',
  'sf.unsupportedTitle': 'این فرم این‌جا نمایش داده نمی‌شود',
  'sf.unsupportedBody':
    'از قالب فرم جدیدتری از آنچه این نسخه برنامه می‌فهمد استفاده می‌کند. هیچ‌چیز درباره پاسخ‌ها از بین نمی‌رود یا عوض نمی‌شود — نمایشش به برنامه به‌روز شده نیاز دارد.',
  'sf.incompleteTitle': 'پاسخ‌های الزامی کم است',
  'sf.incompleteBody': 'امضا به پاسخ دادن هر پرسش الزامی قابل مشاهده نیاز دارد. به هر کدام بروید:',
  'sf.answeredOf': '{answered, number} از {total, number} پاسخ داده شده',
  'sf.missingCount': '{n, number} الزامی مانده',
  'sf.saving': 'در حال ذخیره…',
  'sf.saved': 'ذخیره شد',
  'sf.saveFailed': 'ذخیره نشد — ورودی‌های شما این‌جا نگه داشته می‌شوند.',
  'sf.retry': 'تلاش دوباره',
  'sf.yes': 'بله',
  'sf.no': 'خیر',
  'sf.clear': 'پاک کردن پاسخ',
  'sf.note': 'یادداشت',
  'sf.addNote': 'افزودن یادداشت',
  'sf.noAnswer': 'پاسخ داده نشده',
  'sf.numberInvalid': 'یک عدد وارد کنید.',
  'sf.numberRange': 'بین {min, number} و {max, number}.',
  'sf.numberMin': 'دست‌کم {min, number}.',
  'sf.numberMax': 'حداکثر {max, number}.',
  'sf.minSelections': 'دست‌کم {n, number} گزینه انتخاب کنید — تا آن موقع همین‌جا نگه داشته می‌شود.',
  'sf.maxSelections': 'حداکثر {n, number} گزینه.',
  'sf.incompleteBanner': 'امضا نشد — {n, number} پرسش الزامی در فرم ساخت‌یافتهٔ پایین بی‌پاسخ است.',
  'sf.autosaveFailedBanner':
    'امضا متوقف شد: آخرین پاسخ‌های فرم ذخیره نشدند. هیچ‌چیز از آنچه وارد کردید از بین نرفت — در فرم ذخیره را دوباره امتحان کنید، بعد دوباره امضا کنید.',
  /* پیوند ارزیابی به جلسهٔ رزروشده (ZOY-545/552). */
  'as.forBookedTitle': 'برای یک جلسه رزرو شده',
  'as.forBookedBody':
    'این ارزیابی جلسه رزرو شده‌ای را ثبت می‌کند که از آن شروع می‌شود. پیوند هنگام ساخت تنظیم می‌شود و هیچ‌وقت عوض نمی‌شود.',
  'as.err.bookingAssessed':
    'آن جلسهٔ رزروشده از قبل ارزیابی خودش را دارد — هر جلسه دقیقاً یک ارزیابی می‌گیرد.',
  'as.err.bookingNotAssessment':
    'خدمت رزرو شده گردش‌کار «ارزیابی» را اعلام نمی‌کند، بنابراین ارزیابی نمی‌تواند به آن بچسبد.',
  'as.err.bookingNotActive': 'آن رزرو دیگر فعال نیست، بنابراین کار بالینی‌ای برای ارزیابی ندارد.',
  'as.sessionAssessTitle': 'ارزیابی این جلسه',
  'fmt.defaultChip': 'پیش‌فرض',
  /* وضعیت‌های ذخیرهٔ فرم (ZOY-538) — فقط خطای گذرا امکان تلاش دوباره دارد. */
  'sf.saveStale':
    'این فرم دیگر فرم زنده نیست — جای دیگری عوض یا کنار گذاشته شد. ارزیابی را دوباره باز کنید تا وضعیت فعلی را ببینید.',
  'sf.saveRejected':
    'یک پاسخ پذیرفته نشد، بنابراین آن تغییر ذخیره نشد. هر چه روی صفحه است نگه داشته می‌شود — تنظیمش کنید و دوباره ذخیره می‌شود.',
  'sf.saveForbidden': 'مجوز شما برای ویرایش این ارزیابی تمام‌شده. چیزی ذخیره نشد.',
  /* انتخاب قالب (ZOY-538/544) */
  'fmt.currentChip': 'انتخاب فعلی',
  'fmt.onlyCurrent': 'این تنها قالب ساختاریافته در دسترس است، و از قبل این‌جا در استفاده است.',
  'fmt.errSignedOff': 'این ارزیابی امضا شده، بنابراین قالبش دیگر عوض نمی‌شود.',
  'fmt.errSealed': 'این فرم با ارزیابی امضا شده مهر و موم شد و دیگر کنار گذاشته نمی‌شود.',
  'fmt.errGone': 'آن فرم دیگر فرم زنده این‌جا نیست — صفحه به‌روز شد.',
  'fmt.errUnavailable': 'آن قالب دیگر برای شروع در دسترس نیست. فهرست به‌روز شد.',
  /* رد شدن‌های ارزیابی رزروشده (ZOY-552) */
  'as.err.bookingNotFound':
    'آن جلسه رزرو شده پیدا نشد، بنابراین چیزی ساخته نشد. دوباره از تقویم بازش کنید و تلاش کنید.',
  'as.err.bookingMismatch': 'آن جلسه رزرو شده مال مراجع دیگری است، بنابراین چیزی ساخته نشد.',
};
